import type { Maestro } from '@/types/maestro.ts';

interface MaestroAvatarProps {
  maestro: Maestro;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const SIZES = {
  sm: { box: 'h-11 w-11 rounded-xl', icon: 'size-5' },
  md: { box: 'h-14 w-14 rounded-2xl', icon: 'size-7' },
  lg: { box: 'h-20 w-20 rounded-[1.4rem]', icon: 'size-9' },
} as const;

/**
 * Unified maestro visual: a rounded gradient tile (tinted with the maestro's
 * accent colour) holding a clean lucide icon. Mirrors the icon-tile language of
 * the home / flow cards, replacing the old emoji so the simulation flow matches
 * the polished first pages.
 */
export default function MaestroAvatar({ maestro, size = 'md', className = '' }: MaestroAvatarProps) {
  const s = SIZES[size];
  const Icon = maestro.Icon;
  return (
    <div
      className={`flex shrink-0 items-center justify-center text-white ${s.box} ${className}`}
      style={{
        background: `linear-gradient(135deg, ${maestro.accentColor}, ${maestro.accentColorLight})`,
        boxShadow: `0 12px 26px -12px ${maestro.accentColor}cc`,
      }}
    >
      <Icon className={s.icon} strokeWidth={2} aria-hidden="true" />
    </div>
  );
}
